import React from 'react';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import LocalStorageHelper from '../../../utils/LocalStorageHelper';
import { CircleShadow } from '..';

class SideBarContainer extends React.Component {
  componentWillMount() {
    const sidebarState = LocalStorageHelper.getData('sidebarState');
    const collapsed = sidebarState ? sidebarState.collapsed : false;
    this.setState({ collapsed });
  }

  componentDidUpdate(prevProps, prevState) {
    const { setActiveSettlement } = this.props;
    if (prevProps.setActiveSettlement !== prevState.collapsed && prevProps.setActiveSettlement !== setActiveSettlement) {
      this.toggleCollapsedState();
    }
  }

  toggleCollapsedState = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
    this.saveSideBarStatus(!collapsed);
  };

  saveSideBarStatus(collapsed) {
    const sidebarState = {
      collapsed,
    };
    LocalStorageHelper.storeData('sidebarState', sidebarState);
  }

  render() {
    const { children, hideCollapseButton, display } = this.props;
    const { collapsed } = this.state;
    const classes = classNames('default-sidebar', { collapsed });
    return (
      <aside className={classes}>
        <div className="expanded-area">{children}</div>
        <div className="collapsed-area">
          <div className="tab-side-bar">
            <CircleShadow onClick={this.toggleCollapsedState} visible={!hideCollapseButton} display={display} noBackground>
              <FontAwesomeIcon icon={faArrowLeft} />
            </CircleShadow>
          </div>
        </div>
      </aside>
    );
  }
}

export default SideBarContainer;
